
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SonarPingEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(3 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width;
                const ry = (this.pseudoRandom(i + 10) - 0.5) * height;
                const life = (curTime * 0.3 + i / count) % 1;
                const r = life * 400 * scale;
                const alpha = (1 - life) * 0.5;
                
                ctx.save();
                ctx.globalAlpha = alpha / layerIndex;
                ctx.lineWidth = 2 * scale;
                ctx.beginPath();
                ctx.arc(rx, ry, r, 0, Math.PI * 2);
                ctx.stroke();
                
                // Directional blip
                ctx.beginPath();
                ctx.moveTo(rx, ry);
                ctx.lineTo(rx + Math.cos(curTime + i) * r, ry + Math.sin(curTime + i) * r);
                ctx.stroke();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
